// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-card[data-v-7540bdc8]{background-position:50%;background-size:cover;background-repeat:no-repeat}.v-card[data-v-7540bdc8]{overflow:hidden}*[data-v-7540bdc8]{word-break:break-word!important}", ""]);
// Exports
module.exports = exports;
